const HEX = /^#[0-9A-Fa-f]{6}$/;
const pick = (v, d) => (HEX.test(v || "") ? v : d);

export function FestivalPhonePreview({ fest, base }) {
  const primary = pick(fest.primary_color, base?.primary_color || "#0C831F");
  const accent = pick(fest.accent_color, base?.accent_color || "#F8CB46");
  const radius = Number(base?.corner_radius ?? 12);
  const font = base?.font_family || "Poppins";
  const banner = /^https:\/\//.test(fest.banner_image_url || "") ? fest.banner_image_url : null;
  return (
    <div className="w-[230px] shrink-0 mx-auto" data-testid="fest-phone-preview">
      <div className="rounded-[2rem] border-[6px] border-neutral-800 bg-white shadow-xl overflow-hidden" style={{ fontFamily: `"${font}", ui-sans-serif, system-ui, sans-serif` }}>
        <div className="h-5 bg-neutral-800 flex justify-center"><div className="w-16 h-3 rounded-b-xl bg-black" /></div>
        <div className="px-3 pt-3 pb-4 text-white" style={{ background: primary }} data-testid="fest-preview-header">
          <div className="text-[10px] opacity-80">Delivering to Home</div>
          <div className="text-sm font-bold">Sonu Ki Dukaan</div>
          <div className="mt-2 bg-white/95 text-neutral-400 text-[10px] px-2 py-1.5" style={{ borderRadius: radius }}>Search for atta, milk, sweets…</div>
        </div>
        <div className="p-2.5 space-y-2.5">
          <div className="relative overflow-hidden h-24 flex items-end" style={{ borderRadius: radius, background: banner ? `center/cover url("${banner}")` : `linear-gradient(135deg, ${primary}, ${accent})` }} data-testid="fest-preview-banner">
            <div className="w-full p-2 bg-gradient-to-t from-black/60 to-transparent text-white">
              <div className="text-xs font-bold leading-tight" data-testid="fest-preview-greeting">{fest.greeting || `Happy ${fest.name || "Festival"}!`}</div>
              <div className="text-[9px] opacity-90">{fest.name || "Festival name"} offers inside</div>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-2">
            {["Sweets", "Diyas"].map((n) => (
              <div key={n} className="border p-1.5" style={{ borderRadius: radius }}>
                <div className="h-10 bg-neutral-100 mb-1" style={{ borderRadius: radius / 2 }} />
                <div className="text-[9px] font-semibold text-neutral-800">{n}</div>
                <div className="flex items-center justify-between mt-1">
                  <span className="text-[9px] font-bold text-neutral-800">₹40 <s className="text-neutral-400 font-normal">₹45</s></span>
                  <span className="text-[8px] font-bold px-1.5 py-0.5 border" style={{ color: primary, borderColor: primary, borderRadius: radius / 2 }}>ADD</span>
                </div>
              </div>
            ))}
          </div>
          <div className="text-[9px] font-bold text-neutral-900 px-2 py-1.5 text-center" style={{ background: accent, borderRadius: radius }} data-testid="fest-preview-accent">Festive offer — free delivery today</div>
        </div>
      </div>
      <p className="text-[10px] text-center text-muted-foreground mt-2">Live preview — not saved yet</p>
    </div>
  );
}
